<div class="grid p-fluid py-5">
    <div class="col-12 flex justify-content-center align-item-center">
        <div class="card flex gap-2">
            <h3 class="my-auto" *ngIf="currentLocation">Location- {{currentLocation}}</h3>
            <a pButton [href]="'/portal'" class="no-underline w-auto" severity="primary" label="Back to Portal"></a>
            <p-fileUpload mode="basic" [chooseLabel]="getImortSheetLabel"
                chooseIcon="pi pi-file-import" name="dailySummaryFile[]" [accept]="getSupportedMimeTypes" (onSelect)="importSheet($event)"
                (onClear)="clearSheetSeletion()" [multiple]="true" [showCancelButton]="true"
                #dailySummarySheetFileUpload />

            <p-button severity="primary" label="Clear" (onClick)="dailySummarySheetFileUpload.clear()"
                *ngIf="dailySummarySheetFileUpload?.files?.length" />
        </div>
    </div>
    <div class="col-12 flex justify-content-center align-item-center" id="please-select-message">
        <small *ngIf="!settingsError">Please select daily import sheet for {{ dailySummaryReportType }}.</small>
        <small *ngIf="settingsError" class="text-red-500 font-bold">Error: Failed to load daily summary settings.
          Please check you are logged into the correct location.</small>
    </div>
    <div class="col-12 flex justify-content-center align-item-center">
        <p-messages class="w-full lg:w-6" />
    </div>
    <div class="col-12" *ngIf="dailySummarySheetFileUpload?.files?.length || this.testFileLoaded === true;">
        <div class="card">
            <div *ngIf="loading else loadTable">
                <p-progressSpinner ariaLabel="loading" />
            </div>
            <ng-template #loadTable>
                <div *ngIf="importedSheetData || fileImportData.length">
                    <div class="col-10 m-auto" *ngIf="dailySummaryReportType == 'surepark'">
                        <div class="col-12 flex align-items-center justify-content-start gap-2">
                            <h3>Date : <span class="font-normal">{{ fileImportData[0]['date'] }}</span></h3>
                            <p-button severity="success" label="Import Daily Summary" (onClick)="importSummaryData()" [loading]="importSummaryInProgress"/>
                            <p-button severity="warning" label="Clear Previous Daily Summary Import" (onClick)="clearSummaryData(fileImportData[0]['date'])" [loading]="importSummaryInProgress"/>
                        </div>
    
                        <div class="col-12">
                            <p-table [value]="dailySummaryData['rows']" [columns]="dailySummaryData['columns']">
                                <ng-template pTemplate="caption">
                                    <div class="flex align-items-center justify-content-between">
                                        Daily Tickets Collected Summary
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let column of columns">{{column.header}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-customer let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns">
                                            {{ col?.prefix }} {{ customer[col.field] }}
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <tr>
                                        <td [attr.colspan]="columns.length" class="text-center font-bold">No Daily Tickets Collected Summary Found.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
    
                        <div class="col-12">
                            <p-table [value]="fileImportData[0]['ticket_summary']['rows']" [columns]="fileImportData[0]['ticket_summary']['columns']">
                                <ng-template pTemplate="caption">
                                    <div class="flex align-items-center justify-content-between">
                                        Tickets Summary
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let column of columns">{{column.header}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-customer let-rowIndex="rowIndex" let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns">
                                            {{customer[col.field]}}
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <tr>
                                        <td [attr.colspan]="columns.length" class="text-center font-bold">No Tickets Summary Found.</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <tr>
                                        <td *ngFor="let col of fileImportData[0]['ticket_summary']['columns']">
                                            {{ fileImportData[0]['ticket_summary']['summary'][0][col.field] }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
    
                        <div class="col-12">
                            <p-table [value]="fileImportData[0]['revenue']['rows']" [columns]="fileImportData[0]['revenue']['columns']">
                                <ng-template pTemplate="caption">
                                    <div class="flex align-items-center justify-content-between">
                                        Revenue
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let column of columns">{{column.header}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-customer let-rowIndex="rowIndex" let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns">
                                            {{customer[col.field]}}
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <tr>
                                        <td [attr.colspan]="columns.length" class="text-center font-bold">No Revenue Found.</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <tr *ngFor="let revenueSummary of fileImportData[0]['revenue']['summary']">
                                        <td *ngFor="let col of fileImportData[0]['revenue']['columns']">
                                            {{ revenueSummary[col.field] }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="col-12" *ngIf="fileImportData[0]?.['lost_tickets']">
                            <p-table [value]="fileImportData[0]['lost_tickets']['rows']" [columns]="fileImportData[0]['lost_tickets']['columns']">
                                <ng-template pTemplate="caption">
                                    <div class="flex align-items-center justify-content-between">
                                        Lost Tickets
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let column of columns">{{column.header}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-customer let-rowIndex="rowIndex" let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns">
                                            {{customer[col.field]}}
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <tr>
                                        <td [attr.colspan]="columns.length" class="text-center font-bold">No Lost Tickets Found.</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <tr *ngFor="let lostTicketsSummary of fileImportData[0]['lost_tickets']['summary']">
                                        <td *ngFor="let col of fileImportData[0]['lost_tickets']['columns']">
                                            {{ lostTicketsSummary[col.field] }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="dailySummaryReportType == 'cashier'">
                        <cashier-import-sheet-summary [currentLocation]="currentLocation" [importFileData]="importedSheetData" (clearSheetSeletion)="clearSummaryData($event)" (saveDailySummaryData)="saveDailySummaryData($event)"></cashier-import-sheet-summary>
                    </div>
                    <div class="col-12" *ngIf="dailySummaryReportType == 'wps'">
                        <wps-import-sheet-summary [currentLocation]="currentLocation" [importFileData]="importedSheetData" (clearSheetSeletion)="clearSummaryData($event)" (saveDailySummaryData)="saveDailySummaryData($event)"></wps-import-sheet-summary>
                    </div>
                    <div class="col-12" *ngIf="dailySummaryReportType == 'syspark'">
                        <syspark-import-sheet-summary [currentLocation]="currentLocation" [importFileData]="importedSheetData" (clearSheetSeletion)="clearSummaryData($event)" (saveDailySummaryData)="saveDailySummaryData($event)"></syspark-import-sheet-summary>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>

<div class="footer-version">Version: {{version}} {{activeFile}}</div>
